import styled from "styled-components";

const Body = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  padding-top: 0px;
  flex: 1;
`;
const ColumnFlex = styled.div`
    display: flex;
    flex-direction: column;
`
const UploadButton = styled.div`
  display: flex;
  margin-top: 24px;
  border: 1px dashed #436ab2;
  border-radius: 10px;
  padding: 48px;
  justify-content: center;
  transition: 0.2s all ease-in-out;
  cursor: pointer;
  & > input {
    display: none;
  }
  & > p {
    transition: 0.2s all ease-in-out;
  }
  &:hover > p {
    color: #436ab2;
  }
  &:hover {
    border: 1px solid #436ab2;
    background-color: rgba(67, 106, 178, 0.1);
  }
`;
const AmountDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const Error = styled.p`
  color: red;
  font-size: 1.4rem;
  margin-top: 4rem;
  position: absolute;
  z-index: 9;
`;

const InputFieldWrapper = styled.div`
  display: flex;
  width: 324px;
  margin-top: 24px;
  border: 1px solid #436ab2;
  border-radius: 6px;
  padding: 5px;
  justify-content: left;
  cursor: pointer;
  height: 50px;
`;

const Input = styled.input`
  border: 0;
  outline: none;
  height: auto;
  width: 100%;
  font-size: medium;
  padding-left: 18px;
`;

export { Body, UploadButton, AmountDiv, Error, InputFieldWrapper, Input, ColumnFlex };
